<template>
	<v-list class="overflow-hidden fill-height">
		<v-skeleton-loader v-for="n in total" :key="n" :type="type" boilerplate />
	</v-list>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			default: "list-item",
		},
		total: {
			type: Number,
			default: 10,
		},
		boilerplate: Boolean,
	},
};
</script>
